
import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'MonitorApi' })
export default class MonitorApi extends Vue {}
